import useTranslation from 'next-translate/useTranslation'
import ItReportCard from '../organisms/ItReportCard'

const ItReportTemplate = () => {
  const { t, lang } = useTranslation('it_report')

  return (
    <main className='bg-black py-4 text-white'>
      <div className='container container-medium h-full my-24'>
        <h1 className='mt-10 text-4.5xl text-center'>{t('title')}</h1>
        <div className='text-3xl text-center my-8'>
          <div>{t('text1')}</div>

          <div>{t('text2')}</div>
        </div>
        {/* {lang === 'pl' && (
          <section className='py-8'>
            <div className=' bg-gray-bg rounded-xl p-6 text-black flex sm:flex-row flex-col items-center justify-between animate-[pulse_1s_ease-in-out_1]'>
              <div className='text-3xl'>
                Rozpoczęliśmy zbieranie ankiet do{' '}
                <b>Badania Społeczności IT 2025</b>. Koniecznie weź udział 👉
              </div>
              <a
                href='/it-report/survey?utm_source=report&utm_medium=page'
                className=' bg-primary shrink-0 text-white px-6 py-4 text-lg block rounded-full text-center text-xl duration-300 hover:bg-primary-hover sm:mt-0 mt-4'
              >
                Wypełnij badanie!
              </a>
            </div>
          </section>
        )} */}
        <section className='py-16'>
          <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-8 md:gap-12 md:gap-y-20 gap-y-20 my-4'>
            <ItReportCard
              title={t('report-kind-salary')}
              text={t('report-kind-salary-description')}
              dogClass='fill-yellow-200 text-yellow-200'
              links={[
                {
                  href: '/it-report/salaries',
                  text: t('report-kind-salary-button'),
                },
              ]}
            />
            <ItReportCard
              title={t('report-kind-community')}
              text={t('report-kind-community-description')}
              dogClass='fill-teal text-teal'
              links={[
                {
                  href: '/it-report/2025',
                  text: '2025',
                  plaque: 'New!',
                },
                {
                  href: '/it-report/2024',
                  text: '2024',
                },
                {
                  href: '/it-report/2023',
                  text: '2023',
                },
                {
                  href: '/it-report/2022',
                  text: '2022',
                },
                {
                  href: '/it-report/2021',
                  text: '2021',
                },
                {
                  href: '/it-report/2020',
                  text: '2020',
                },
                {
                  href: '/it-report/2019',
                  text: '2019',
                },
              ]}
            />
            <ItReportCard
              title={t('report-kind-diversity')}
              text={t('report-kind-diversity-description')}
              dogClass='fill-action-500 text-action-500'
              links={[
                {
                  href: '/it-report/diversity/2024',
                  text: '2024',
                },
                {
                  href: '/it-report/diversity',
                  text: '2023',
                },
              ]}
            />
          </div>
        </section>
      </div>
    </main>
  )
}

export default ItReportTemplate
